// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item-action-col {\n  width: 27px;\n}\n#vs7__listbox {\n  z-index: -1;\n}\n[dir] .v-select.item-selector-title, [dir] .v-select.payment-selector {\n  background-color: #fff;\n}\n[dir] .dark-layout .v-select.item-selector-title, [dir] .dark-layout .v-select.payment-selector {\n  background-color: unset;\n}", ""]);
// Exports
module.exports = exports;
